<div class="mt-2">
    <th-new-data-table [definition]="tableDefinition" [data]="logEvents"></th-new-data-table>
</div>